// src/pages/traduccion_especializada.js

import React from "react";
import Header from '../../components/Header'
import Footer from '../../components/Footer'

function TraduccionNoCertificada() {
    return (
        <>
            <Header />
            {/* CABECERA */}
            <section className="p__cabecera" id="inicio">
                <div className="wrap text-center">
                    <h1>Traducción no Certificada o Simple</h1>
                    <p>
                        Expertos en cada área que garantizan la precisión
                        terminológica.
                    </p>
                </div>
            </section>

            {/* SERVICIO */}
            <section className="empresa" id="empresa">
                <div className="wrap servicios">

                    {/* ESCRITORIO */}
                    <div className="emp3" style={{ padding: "50px" }}>
                        <ul className="mt-3">
                            <li style={{ marginBottom: "15px", listStyle: "none" }}>
                                <i className="fas fa-circle-check"></i>
                                <span> Se realiza por un traductor profesional con experiencia en el tema a traducir</span>
                            </li>
                            <li style={{ marginBottom: "15px", listStyle: "none" }}>
                                <i className="fas fa-circle-check"></i>
                                <span> No tiene validez legal ni cuenta con firma y sello del traductor colegiado</span>
                            </li>
                        </ul>


                    </div>
                    <div className="emp4" style={{ padding: "50px" }}>
                        <h3 className="text-left eyebrow font-bold" style={{ fontSize: "24px" }}>Incluye todo tipo de texto que requiere ser traducido: </h3>
                        <ul className="mt-3">
                            <li style={{ marginBottom: "15px", listStyle: "none" }}>
                                <i className="fas fa-asterisk"></i>
                                <span> Currículum vítae</span>
                            </li>
                            <li style={{ marginBottom: "15px", listStyle: "none" }}>
                                <i className="fas fa-asterisk"></i>
                                <span> Trabajos de investigación</span>
                            </li>
                            <li style={{ marginBottom: "15px", listStyle: "none" }}>
                                <i className="fas fa-asterisk"></i>
                                <span> Contenidos de páginas web</span>
                            </li>
                            <li style={{ marginBottom: "15px", listStyle: "none" }}>
                                <i className="fas fa-asterisk"></i>
                                <span> etc</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
}

export default TraduccionNoCertificada;